import { getCsrfToken } from "next-auth/react";

type UpdateSessionData = { token: string };

// In next-auth v4, session updates are handled via the jwt callback's
// trigger === "update" mechanism. The POST body must include:
// - csrfToken: validated against the cookie by next-auth (csrf-token.js:18)
// - data: the payload forwarded to the jwt callback as `session` (core/index.js:309)
export const updateSession = async (data: UpdateSessionData): Promise<void> => {
  const csrfToken = await getCsrfToken();

  await fetch("/api/auth/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ csrfToken, data }),
  });
};
